export default __webpack_public_path__ + "static/media/story10.d29e0984.jpg";